import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { usePayments } from '../hooks/usePayments';
import Loading from './Loading';

const RedirectRoute = ({children}) => {
    const { user } = useAuth();
    const { getCurrentPlan } = usePayments();
    const location = useLocation();
    const [hasSubscription, setHasSubscription] = useState(null); // null = loading, true/false = known
    const [isChecking, setIsChecking] = useState(true);
    
    useEffect(() => {
        const checkSubscription = async () => {
            if (user?.uid) {
                try {
                    const subscription = await getCurrentPlan(user.uid);
                    setHasSubscription(subscription?.status === 'active');
                } catch (err) {
                    console.error('Error checking subscription:', err);
                    setHasSubscription(false);
                }
            } else {
                setHasSubscription(false);
            }
            setIsChecking(false);
        };
        checkSubscription();
    }, [user?.uid, getCurrentPlan]);
    
    // If user is logged in and verified
    if (user && user.emailVerified) {
        // On /signup page - check if they have a subscription
        if (location.pathname === '/signup') {
            // Still checking subscription - show loading
            if (isChecking) {
                return <Loading message="Checking subscription..." />;
            }
            // No subscription - allow access to signup for plan selection
            if (!hasSubscription) {
                return children;
            }
            // Has subscription - redirect to home
            return <Navigate to='/' />;
        }
        // Other pages - redirect to home
        return <Navigate to='/' />;
    }
    
    // If user is logged in but unverified
    if (user && !user.emailVerified) {
        // Allow access to verifyemail page
        if (location.pathname === '/verifyemail') {
            return children;
        }
        // Redirect signin/signup to verifyemail (they're already logged in)
        if (location.pathname === '/signin' || location.pathname === '/signup') {
            return <Navigate to='/verifyemail' />;
        }
        // For other pages (like thankyou), show them
        return children;
    }
    
    // Not logged in - show the page (signin/signup forms)
    // But not verifyemail - redirect to signin
    if (location.pathname === '/verifyemail') {
        return <Navigate to='/signin' />;
    }
    
    return children;
}

export default RedirectRoute;